import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Typography, DialogContentText, Divider, MenuItem, Grid, InputLabel, TextField, TableCell, TableRow, TableContainer, TableBody, Table, TableHead, Chip, Switch } from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import DeleteIcon from '@material-ui/icons/Delete';
import tokenDecoder from '../../../utils/tokenDecoder';
import { useParams } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    table: {
        minWidth: 550,
    },
}));

const screenCode = "SKUCATEGORY"
export default function SKUCategoryAddEdit() {
    const classes = useStyles();
    const navigate = useNavigate();
    const alert = useAlert();
    const [title, setTitle] = useState("Add SKU Category ")
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [budgetCodes, setBudgetCodes] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);
    const [isAdd, setIsAdd] = useState(false);
    const [ArrayField, setArrayField] = useState([]);
    const [skuCategoryCode, setSKUCategoryCode] = useState("");
    const [backConfirmation, setBackConfirmation] = useState(false);
    const [isExecuteButtonDisabled, setIsExecuteButtonDisabled] = useState(false);
    const [updateArrayField, setupdateArrayField] = useState([]);
    const [saveArrayField, setSaveArrayField] = useState([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [SKUCategoryDetails, setSKUCategoryDetails] = useState({
        groupID: 0,
        factoryID: 0,
        budgetCodeID: 0,
        skuCategoryCode: '',
        skuCategoryName: '',
        skuCategoryDescription: '',
        isActive: true,
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
    });

    const { skuCategoryID } = useParams();
    let decrypted = 0

    const empNoRef = useRef(null);
    const descriptionRef = useRef(null);
    const recordCount = ArrayField.length;

    useEffect(() => {
        decrypted = atob(skuCategoryID.toString());
        if (parseInt(decrypted) > 0) {
            setIsUpdate(true);
            GetDetailsBySKUCategoryID(decrypted);
        }
    }, []);

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermissions(), getBudgetCodeDetails());
    }, []);

    useEffect(() => {
        if (SKUCategoryDetails.groupID != 0) {
            trackPromise(
                getFactoriesForDropdown(SKUCategoryDetails.groupID)
            );
        }
    }, [SKUCategoryDetails.groupID])

    const handleClick = () => {
        navigate('/app/SKUCategory/listing');
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITSKUCATEGORY');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setSKUCategoryDetails({
            ...SKUCategoryDetails,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken()),
        })
    }

    async function getBudgetCodeDetails() {
        var response = await services.getBudgetCodeDetails();
        setBudgetCodes(response);
    }

    function clearData() {
        setSKUCategoryDetails({
            ...SKUCategoryDetails,
            skuCategoryCode: '',
            skuCategoryName: '',
            skuCategoryDescription: '',
            isActive: true,
        });
        setSKUCategoryCode([])
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getFactoriesForDropdown(groupID) {
        const factories = await services.getAllFactoriesByGroupID(groupID);
        setFactories(factories);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setSKUCategoryDetails({
            ...SKUCategoryDetails,
            [e.target.name]: value
        });
    }

    function handleChangeempNo(e) {
        const value = e.target.value.replace(/\s/g, "");
        setSKUCategoryCode(value);
    }


    const handleKeyDown = (event, nextInputRef) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            nextInputRef.current.focus();
        }
    }

    async function InactivDetails(row, index) {
        {
            const dataDelete = [...ArrayField];
            const remove = index;
            dataDelete.splice(remove, 1);
            setArrayField([...dataDelete]);
        }
    };

    async function addSKUCategoryDetails() {
        if (skuCategoryCode == null) {
            alert.error("Please enter SKU Category Code");
            return;
        }

        let model = {
            groupID: parseInt(SKUCategoryDetails.groupID),
            factoryID: parseInt(SKUCategoryDetails.factoryID),
            budgetCodeID: parseInt(SKUCategoryDetails.budgetCodeID),
            skuCategoryCode: skuCategoryCode,
            skuCategoryName: SKUCategoryDetails.skuCategoryName,
            skuCategoryDescription: SKUCategoryDetails.skuCategoryDescription,
        };
        if (isUpdate == true) {
            setIsAdd(false);
            let model = {
                groupID: parseInt(SKUCategoryDetails.groupID),
                factoryID: parseInt(SKUCategoryDetails.factoryID),
                budgetCodeID: parseInt(SKUCategoryDetails.budgetCodeID),
                skuCategoryCode: skuCategoryCode,
                skuCategoryName: SKUCategoryDetails.skuCategoryName,
                skuCategoryDescription: SKUCategoryDetails.skuCategoryDescription,
                modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
                skuCategoryID: parseInt(atob(skuCategoryID).toString()),
                isActive: SKUCategoryDetails.isActive,
            };
            let response = await services.UpdateSKUCategoryDetails(model);
            if (response.statusCode == "Success") {
                alert.success(response.message);
                setArrayField([]);
                navigate('/app/SKUCategory/listing');
            } else {
                alert.error(response.message);
            }
        } else {
            const alreadyExist = ArrayField.find(p => p.skuCategoryCode == skuCategoryCode, p => p.skuCategoryName == SKUCategoryDetails.skuCategoryName);
            if (alreadyExist !== undefined) {
                alert.error("This SKU Category Added Already");
                return;
            }
            let response = await services.findExistsRecord(model);
            if (response.data < 0) {
                alert.error(response.message);
                return;
            }

            const isMatch = ArrayField.some(x =>
                x.budgetCodeID === parseInt(SKUCategoryDetails.budgetCodeID) &&
                (x.skuCategoryCode === skuCategoryCode ||
                    x.skuCategoryName === SKUCategoryDetails.skuCategoryName)
            );

            if (isMatch) {
                alert.error("The record already exists!");
            } else {
                var array1 = [...ArrayField];
                array1.push({
                    groupID: parseInt(SKUCategoryDetails.groupID),
                    factoryID: parseInt(SKUCategoryDetails.factoryID),
                    budgetCodeID: parseInt(SKUCategoryDetails.budgetCodeID),
                    skuCategoryCode: skuCategoryCode,
                    skuCategoryName: SKUCategoryDetails.skuCategoryName,
                    skuCategoryDescription: SKUCategoryDetails.skuCategoryDescription,
                    skuCategoryID: parseInt(atob(skuCategoryID).toString()),
                    isActive: SKUCategoryDetails.isActive,
                    createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
                });
                setArrayField(array1);
                setIsAdd(true);
                setSKUCategoryDetails({
                    ...SKUCategoryDetails,
                    skuCategoryName: '',
                    skuCategoryCode: '',
                    skuCategoryDescription: '',
                    isActive: true,
                });
                setSKUCategoryCode([]);
                var checkExistingData = await services.CheckEmpAttendanceCheckDatabase(
                    skuCategoryCode,
                    SKUCategoryDetails.skuCategoryName
                );
                if (checkExistingData.length > 0) {
                    if (checkExistingData[0].skuCategoryCode === skuCategoryCode) {
                        var updateDataArray = [...updateArrayField];
                        updateDataArray.push({
                            groupID: parseInt(SKUCategoryDetails.groupID),
                            factoryID: parseInt(SKUCategoryDetails.factoryID),
                            budgetCodeID: parseInt(SKUCategoryDetails.budgetCodeID),
                            skuCategoryCode: skuCategoryCode,
                            skuCategoryName: SKUCategoryDetails.skuCategoryName,
                            skuCategoryDescription: SKUCategoryDetails.skuCategoryDescription,
                            skuCategoryID: parseInt(atob(skuCategoryID).toString()),
                            createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
                            isActive: SKUCategoryDetails.isActive,
                        });
                        setupdateArrayField(updateDataArray);
                    }
                } else {
                    var saveDataArray = [...saveArrayField];
                    saveDataArray.push({
                        groupID: parseInt(SKUCategoryDetails.groupID),
                        factoryID: parseInt(SKUCategoryDetails.factoryID),
                        budgetCodeID: parseInt(SKUCategoryDetails.budgetCodeID),
                        skuCategoryCode: skuCategoryCode,
                        skuCategoryName: SKUCategoryDetails.skuCategoryName,
                        skuCategoryDescription: SKUCategoryDetails.skuCategoryDescription,
                        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
                        skuCategoryID: parseInt(atob(skuCategoryID).toString()),
                        isActive: SKUCategoryDetails.isActive,
                    });
                    setSaveArrayField(saveDataArray);
                    setSKUCategoryDetails({
                        ...SKUCategoryDetails,
                        skuCategoryName: '',
                        skuCategoryCode: '',
                        skuCategoryDescription: '',
                        isActive: true,
                    });
                }
            }
        }
    }

    async function saveDetails() {
        setIsButtonDisabled(true);
        if (updateArrayField.length > 0) {
            let responses = await services.UpdateSKUCategoryDetails(updateArrayField);
            if (responses.statusCode == "Success") {
                alert.success(responses.message);
                setupdateArrayField([]);
                navigate('/app/SKUCategory/listing');
            } else {
                alert.error(response.message);
            }
        }
        if (ArrayField.length > 0) {
            var response = await services.saveDetails(ArrayField);
            if (response.statusCode == "Success") {
                alert.success(response.message)
                setArrayField([]);
                setSaveArrayField([]);
                navigate('/app/SKUCategory/listing');
            }
            else {
                alert.error(response.message);
            }
        }
        setIsButtonDisabled(false);
    }

    async function GetDetailsBySKUCategoryID(skuCategoryID) {
        const response = await services.GetDetailsBySKUCategoryID(skuCategoryID);
        setIsUpdate(true);
        setSKUCategoryDetails({
            groupID: parseInt(response.groupID),
            factoryID: parseInt(response.factoryID),
            budgetCodeID: parseInt(response.budgetCodeID),
            skuCategoryCode: response.skuCategoryCode,
            skuCategoryName: response.skuCategoryName,
            skuCategoryDescription: response.skuCategoryDescription,
            modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
            skuCategoryID: parseInt(response.skuCategoryID),
            modifiedDate: new Date().toISOString(),
            isActive: response.isActive,
        });
        setSKUCategoryCode(response.skuCategoryCode);
        setTitle("Edit SKU Category");
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleConfirmBackOne}
                    />
                </Grid>
            </Grid>
        )
    }

    function handleConfirmBack() {
        setBackConfirmation(false)
    }

    function handleConfirmBackOpen() {
        setBackConfirmation(true)
    }

    function handleConfirmBackOne() {
        if (ArrayField.length != 0) {
            handleConfirmBackOpen()
        }
        else {
            handleClick()
        }
    }

    function handleChangeSwitch() {
        setSKUCategoryDetails({
            ...SKUCategoryDetails,
            isActive: !SKUCategoryDetails.isActive
        })
    }

    const handleConfirmBackTwo = () => {
        setBackConfirmation(false);
        navigate('/app/SKUCategory/listing');
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Page
                className={classes.root}
                title={title}
            >
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: SKUCategoryDetails.groupID,
                            factoryID: SKUCategoryDetails.factoryID,
                            budgetCodeID: SKUCategoryDetails.budgetCodeID,
                            skuCategoryName: SKUCategoryDetails.skuCategoryName,
                            skuCategoryCode: skuCategoryCode,
                            skuCategoryDescription: SKUCategoryDetails.skuCategoryDescription,
                            isActive: SKUCategoryDetails.isActive,
                        }}

                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                                budgetCodeID: Yup.number().required('Account Code Name is required').min("1", 'Account Code Name is required'),
                                skuCategoryCode: Yup.string().required('SKU Category Code is required'),
                                skuCategoryName: Yup.string()
                                    .required('SKU Category Name is required')
                                    .matches(/^\S.*\S$|^\S$/, 'Spaces are not allowed at start or end'),
                                skuCategoryDescription: Yup.string()
                                    .max(255, 'SKU Category Description must be at most 255 characters')
                                    .matches(/^\S.*\S$|^\S$|^$/, 'Spaces are not allowed at start or end')
                                    .nullable(),
                            })
                        }
                        onSubmit={() => trackPromise(addSKUCategoryDetails())}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle(title)}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "2rem" }}>
                                                <Grid container spacing={3}>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={SKUCategoryDetails.groupID}
                                                            variant="outlined"
                                                            disabled={isUpdate || ArrayField.length > 0}
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled || isAdd,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            fullWidth
                                                            name="factoryID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={SKUCategoryDetails.factoryID}
                                                            variant="outlined"
                                                            disabled={isUpdate || ArrayField.length > 0}
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            InputProps={{
                                                                readOnly: !permissionList.isFactoryFilterEnabled || isAdd,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="budgetCodeID">
                                                            Account Code Name *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.budgetCodeID && errors.budgetCodeID)}
                                                            fullWidth
                                                            helperText={touched.budgetCodeID && errors.budgetCodeID}
                                                            size='small'
                                                            name="budgetCodeID"
                                                            disabled={isUpdate || ArrayField.length > 0}
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={SKUCategoryDetails.budgetCodeID}
                                                            variant="outlined"
                                                            id="budgetCodeID"
                                                        >
                                                            {generateDropDownMenu(budgetCodes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="skuCategoryCode">
                                                            SKU Category Code *
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.skuCategoryCode && errors.skuCategoryCode)}
                                                            fullWidth
                                                            helperText={touched.skuCategoryCode && errors.skuCategoryCode}
                                                            name="skuCategoryCode"
                                                            onBlur={handleBlur}
                                                            size='small'
                                                            onChange={(e) => handleChangeempNo(e)}
                                                            value={skuCategoryCode}
                                                            variant="outlined"
                                                            id="skuCategoryCode"
                                                            inputRef={empNoRef}
                                                            onKeyDown={(e) => handleKeyDown(e)}
                                                            disabled={isUpdate}
                                                            type="text"
                                                            inputProps={{
                                                                readOnly: isUpdate,
                                                            }}
                                                        >
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="skuCategoryName">
                                                            SKU Category Name *
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.skuCategoryName && errors.skuCategoryName)}
                                                            fullWidth
                                                            helperText={touched.skuCategoryName && errors.skuCategoryName}
                                                            name="skuCategoryName"
                                                            onBlur={handleBlur}
                                                            size='small'
                                                            onChange={(e) => handleChange(e)}
                                                            value={SKUCategoryDetails.skuCategoryName}
                                                            variant="outlined"
                                                            id="skuCategoryName"
                                                            type="text"
                                                        >
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="skuCategoryDescription">
                                                            Description
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.skuCategoryDescription && errors.skuCategoryDescription)}
                                                            helperText={touched.skuCategoryDescription && errors.skuCategoryDescription}
                                                            fullWidth
                                                            size='small'
                                                            name="skuCategoryDescription"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={SKUCategoryDetails.skuCategoryDescription}
                                                            variant="outlined"
                                                            inputRef={descriptionRef}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={3}>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="isActive">
                                                            Active
                                                        </InputLabel>
                                                        <Switch
                                                            checked={SKUCategoryDetails.isActive}
                                                            onChange={handleChangeSwitch}
                                                            name="isActive"
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container justify="flex-end" spacing={3}>
                                                    {!isUpdate ?
                                                        <Box pr={2} style={{ marginTop: '20px' }}>
                                                            <Button
                                                                color="primary"
                                                                variant="outlined"
                                                                type="reset"
                                                                onClick={clearData}
                                                                size='small'
                                                            >
                                                                Clear
                                                            </Button>
                                                        </Box>
                                                        : null}
                                                    <Box pr={2} style={{ marginTop: '20px' }}>
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            type="submit"
                                                            size='small'
                                                            disabled={isExecuteButtonDisabled}
                                                        >
                                                            {((isUpdate == true)) ? "Update" : "Add"}
                                                        </Button>
                                                    </Box>
                                                </Grid>
                                                {ArrayField.length > 0 ? (
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={3} style={{ marginLeft: '10px' }}>
                                                            <Typography color="textSecondary" gutterBottom>
                                                                <Chip
                                                                    style={{ marginLeft: '0', marginRight: '0', backgroundColor: "#FFFDD0", color: 'black', left: '0' }}
                                                                    icon={<AccessTimeIcon />}
                                                                    label={"Record Count: " + recordCount}
                                                                    clickable
                                                                    color="primary"
                                                                />
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                ) : null}
                                                {ArrayField.length > 0 ? (
                                                    <Grid item xs={12}>
                                                        <TableContainer>
                                                            <Table className={classes.table} aria-label="caption table">
                                                                <TableHead>
                                                                    <TableRow>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {ArrayField.map((row, index) => {
                                                                        return <TableRow key={index}>
                                                                        </TableRow>
                                                                    })}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                )
                                                    : null}
                                            </CardContent>
                                            {ArrayField.length > 0 ? (
                                                <Grid item xs={12}>
                                                    <TableContainer>
                                                        <Table className={classes.table} aria-label="caption table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="center"><b>SKU Category Code</b></TableCell>
                                                                    <TableCell align="center"><b>SKU Category Name</b></TableCell>
                                                                    <TableCell align="center"><b>Description</b></TableCell>
                                                                    <TableCell align="center"><b>Action</b></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {ArrayField.map((row, index) => {
                                                                    return <TableRow key={index}>
                                                                        <TableCell align="center" >{row.skuCategoryCode}
                                                                        </TableCell>
                                                                        <TableCell align="center" >{row.skuCategoryName}
                                                                        </TableCell>
                                                                        <TableCell align="center" >{row.skuCategoryDescription == "" ? '-' : row.skuCategoryDescription}
                                                                        </TableCell>
                                                                        <TableCell align='center' scope="row" style={{ borderBottom: "none" }}>
                                                                            <DeleteIcon
                                                                                style={{
                                                                                    color: "red",
                                                                                    marginBottom: "-1rem",
                                                                                    marginTop: "0rem",
                                                                                    cursor: "pointer"
                                                                                }}
                                                                                size="small"
                                                                                onClick={() => InactivDetails(row, index)}
                                                                            >
                                                                            </DeleteIcon>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            )
                                                : null}
                                            {(ArrayField.length > 0) ?
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="button"
                                                        variant="contained"
                                                        size='small'
                                                        onClick={() => saveDetails()}
                                                        disabled={isButtonDisabled}
                                                    >
                                                        {isUpdate == true ? "Update" : "Save"}
                                                    </Button>
                                                </Box>
                                                : null}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
                <Dialog open={backConfirmation}>
                    <DialogTitle id="alert-dialog-slide-title">
                        <Typography
                            color="textSecondary"
                            gutterBottom
                            variant="h3">
                            <Box textAlign="center">
                                Confirmation
                            </Box>
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            <Typography variant="h5">Are you sure do you want to go  back without saving?</Typography>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <br />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleConfirmBackTwo} color="primary">
                            Yes
                        </Button>
                        <Button
                            onClick={handleConfirmBack} color="primary" autoFocus>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </Page >
        </Fragment>
    )
}
